// Icon size and color types
export type IconSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type IconColor =
  | 'primary'
  | 'secondary'
  | 'muted'
  | 'accent'
  | 'success'
  | 'warning'
  | 'error'
  | 'danger'
  | 'disabled'
  | 'inherit'
  | 'current';

// Size class mappings (Tailwind)
export const sizeClasses: Record<IconSize, string> = {
  '2xs': 'h-2.5 w-2.5',
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-12 w-12',
};

// Pixel sizes for inline style override (FontAwesome ignores Tailwind h/w classes)
export const sizePx: Record<IconSize, number> = {
  '2xs': 10,
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 48,
};

// Color class lookup table
const COLOR_CLASS_MAP: Record<IconColor, string> = {
  primary: 'text-foreground',
  secondary: 'text-foreground/80',
  muted: 'text-muted-foreground',
  accent: 'text-muted-foreground',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-destructive-text',
  danger: 'text-destructive-text',
  disabled: 'text-tertiary-foreground',
  inherit: 'text-inherit',
  current: 'text-current',
};

// Get color class for icon
export const getColorClass = (color: IconColor): string => {
  return COLOR_CLASS_MAP[color] ?? 'text-foreground';
};
